"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _colors = _interopRequireDefault(require("../../styles/colors"));
var _react = _interopRequireDefault(require("react"));
var _HBBannerBase = _interopRequireDefault(require("../HBBanner/HBBannerBase"));
var _ExclamationMarkTriangle = _interopRequireDefault(require("@honeybook/icons/dist/icons/ExclamationMarkTriangle24"));
var ErrorBanner = function ErrorBanner(props) {
  return /*#__PURE__*/_react["default"].createElement(_HBBannerBase["default"], (0, _extends2["default"])({
    icon: _ExclamationMarkTriangle["default"],
    primaryActionTheme: "secondary-solid-secondary"
  }, props, {
    accentLine: _colors["default"].red50,
    background: "linear-gradient(0deg, rgba(255, 97, 97, 0.08), rgba(255, 97, 97, 0.08)), rgba(255, 255, 255, 0.2)"
  }));
};
var _default = exports["default"] = ErrorBanner;
//# sourceMappingURL=ErrorBanner.js.map